import { configureStore, applyMiddleware, compose } from "@reduxjs/toolkit";
import {
  AppoinmentReducer,
  UserReducer,
  AuthReducer,
  CountriesReducer,
} from "./rootReducer";
import thunk from "redux-thunk";
const middleware = [thunk];

const userInfoFromStorage = localStorage.getItem("userInfo")
  ? JSON.parse(localStorage.getItem("userInfo"))
  : null;
const initialStore = {
  auth: { userInfo: userInfoFromStorage },
};
const store = configureStore({
  preloadedState: initialStore,
  reducer: {
    appoinments: AppoinmentReducer,
    user: UserReducer,
    auth: AuthReducer,
    countries: CountriesReducer,
  },
  devTools: true,
  middleware: [...middleware],
});
export default store;
